var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Loader } from '../../utils/Loader';
import { Card, Grid } from '@mui/material';
import { GenerateurDevis } from './GenerateurDevis';
import { getInfos, generateDevis } from '../../services/affaire';
import { TYPES } from '../../utils/FormikTextField';
import { FormikGenerator } from '../../utils/FormikGenerator';
import { ExecIcon } from '../../utils/Icons';
import { DevisSchema } from '../../utils/ValidationSchema';
export var GenerateurDocumentAffaire = function (props) {
    var AffaireId = props.AffaireId, ClientId = props.ClientId;
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), infos = _b[0], setInfos = _b[1];
    var _c = useState(null), displayDevis = _c[0], setDisplayDevis = _c[1];
    useEffect(function () {
        var getDatas = function () { return __awaiter(void 0, void 0, void 0, function () {
            var newInfos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getInfos(AffaireId)];
                    case 1:
                        newInfos = (_a.sent()).infos;
                        setInfos(newInfos);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getDatas();
    }, []);
    if (loading) {
        return _jsx(Loader, {});
    }
    return (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsxs(Grid, __assign({ container: true, padding: 2, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 4 }, { children: _jsx(FormikGenerator, { validationSchema: DevisSchema, submitLabel: "G\u00E9n\u00E9rer", submitIcon: ExecIcon, useDirty: false, datas: {
                            Titre: infos.Titre,
                            Numero: infos.Numero,
                            Date: infos.Date,
                            NomRecepteur: infos.NomRecepteur,
                            Paragraphe: infos.Paragraphe,
                        }, onSubmit: function (_a) {
                            var Titre = _a.Titre, Numero = _a.Numero, Date = _a.Date, NomRecepteur = _a.NomRecepteur, Paragraphe = _a.Paragraphe;
                            return __awaiter(void 0, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, generateDevis({
                                                AffaireId: AffaireId,
                                                Titre: Titre,
                                                Numero: Numero,
                                                Date: Date,
                                            })];
                                        case 1:
                                            result = _b.sent();
                                            if (result) {
                                                setDisplayDevis({
                                                    onlyForRefresh: {
                                                        Titre: Titre,
                                                        Numero: Numero,
                                                        Date: Date,
                                                    },
                                                    NomRecepteur: NomRecepteur,
                                                    Paragraphe: Paragraphe,
                                                });
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }, fields: [
                            [
                                {
                                    xs: 12,
                                    name: 'Titre',
                                    label: 'Titre',
                                    type: TYPES.TEXT,
                                    isRequired: true,
                                },
                                {
                                    xs: 12,
                                    name: 'Numero',
                                    label: 'Numéro',
                                    type: TYPES.TEXT,
                                    isRequired: true,
                                },
                                {
                                    xs: 12,
                                    name: 'Date',
                                    label: 'Date',
                                    type: TYPES.TEXT,
                                    datePicker: true,
                                    isRequired: true,
                                },
                                {
                                    xs: 12,
                                    name: 'NomRecepteur',
                                    label: 'Dédié à',
                                    helperText: 'Non sauvegardée',
                                    type: TYPES.TEXT,
                                    isRequired: true,
                                },
                                {
                                    xs: 12,
                                    name: 'Paragraphe',
                                    label: 'Informations complémentaires',
                                    helperText: 'Non sauvegardée',
                                    type: TYPES.TEXT,
                                    multiline: true,
                                },
                            ],
                        ] }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 8 }, { children: displayDevis && (_jsx(GenerateurDevis, { AffaireId: AffaireId, forceInfos: displayDevis })) }))] })) })));
};
//# sourceMappingURL=GenerateurDocumentAffaire.js.map